module.exports = __webpack_public_path__ + "img/SPDP_Logo design_sketch-22.9a8de17e.png";